import AccountCustomerList from "./components/account_customer/AccountCustomerList"
import AccountCustomerEdit from "./components/account_customer/AccountCustomerEdit"
import AccountParticipantEdit from "./components/account_participant/AccountParticipantEdit"
import CampaignEdit from "./components/campaign/CampaignEdit"
import ConditionList from "./components/condition/ConditionList"
import ConditionEdit from "./components/condition/ConditionEdit"
import RuleList from "./components/rule/RuleList"
import RuleEdit from "./components/rule/RuleEdit"
import TransactionList from "./components/transaction/TransactionList"
import TransactionEdit from "./components/transaction/TransactionEdit"
import UserProfileList from "./components/user_profile/UserProfileList"
import UserProfileEdit from "./components/user_profile/UserProfileEdit"
import CampaignList from "./components/campaign/CampaignList"
import AttributeList from "@/views/loyalty/components/attributes/AttributeList"
import AttributeEdit from "@/views/loyalty/components/attributes/AttributeEdit"
import CustomerVariableList from "@/views/loyalty/components/customer_variable/CustomerVariableList"
import CustomerVariableEdit from "@/views/loyalty/components/customer_variable/CustomerVariableEdit"
import CampaignForm from "@/views/loyalty/components/campaign/CampaignForm"
import LoginLoyalty from "@/views/loyalty/components/auth/Login"
import RecoverLoyalty from "@/views/loyalty/components/auth/Recover"
import UserProfileCampaignsList from "@/views/loyalty/components/user_profile/UserProfileCampaignsList.vue"
import CardList from "@/views/loyalty/components/card/CardList.vue"
import PaymentCounterList from "@/views/loyalty/components/payment/PaymentCounterList.vue"

export const router_loyalty = [
    {
        path: "accountcustomer/list/:role",
        name: "AccountCustomerListLink",
        component: AccountCustomerList
    },
    {
        path: "accountcustomer/edit/:role/:campaign/:customer",
        name: "AccountCustomerEditLink",
        component: AccountCustomerEdit
    },
    {
        path: "/accountparticipant/edit/:role",
        name: "AccountParticipantEditLink",
        component: AccountParticipantEdit,
        meta: { needAuth: true }
    },
    {
        path: "attribute/list/:role",
        name: "AttributeListLink",
        component: AttributeList
    },
    {
        path: "attribute/edit/:attributeId",
        name: "AttributeEditLink",
        component: AttributeEdit
    },
    {
        path: "campaign/list/:role",
        name: "CampaignListLink",
        component: CampaignList,
        meta: { needAuth: true }
    },
    {
        path: "campaign/create/:campaign/:customer",
        name: "CampaignEditLink",
        component: CampaignForm
    },
    {
        path: "campaign/edit/:role/:campaign/:customer",
        // name: "CampaignEditLink",
        component: CampaignForm
    },
    {
        path: 'card/list/:role',
        component: CardList
    },
    {
        path: "cvariable/list/:role",
        name: "CustomerVariableListLink",
        component: CustomerVariableList,
        meta: { needAuth: true }
    },
    {
        path: "/cvariable/edit/:cvariableId",
        name: "CustomerVariableEditLink",
        component: CustomerVariableEdit
    },
    {
        path: "condition/list/:role/:rule",
        name: "ConditionListLink",
        component: ConditionList
    },
    {
        path: "condition/edit/:rule/:condition",
        component: ConditionEdit,
        params: true,
        // alias: ["/admin/condition/edit/:rule/:condition", "/client/condition/edit/:rule/:condition"],
        name: "ConditionEditLink",
    },
    {
        path: 'paymentcounter/list/:role',
        component: PaymentCounterList
    },
    {
        path: "rule/list/:role/:campaign",
        name: "RuleListLink",
        component: RuleList
    },
    {
        path: "rule/edit/campaign/rule/:campaignId/:ruleId",
        name: "RuleEditLink",
        component: RuleEdit
    },
    {
        path: "transaction/customer/list/:role",
        name: "TransactionCustomerListLink",
        component: TransactionList
    },
    {
        path: "/transaction/customer/edit",
        name: "TransactionCustomerEditLink",
        component: TransactionEdit
    },
    {
        path: "userprofile/list/:role",
        name: "UserProfileListLink",
        // props: true,
        component: UserProfileCampaignsList
    },
    // {
    //     path: "userprofile/edit/:role/:participant",
    //     name: "UserProfileEditLink",
    //     component: UserProfileEdit
    // }
]

export const routes_loyalty_auth = [
    {
        path: "login",
        name: "LoginLoyaltyLink",
        component: LoginLoyalty
    },
    {
        path: "recover",
        name: "RecoverLoyaltyLink",
        component: RecoverLoyalty
    }
]

export const routes_loyalty_user = [
    {
        path: '/crowd',
        component: () => import('@/views/loyalty/components/core/Index'),
        name: 'Crowd',
        children: [
            {
                name: 'CrowdProfile',
                path: 'profile',
                component: () => import('@/views/loyalty/components/user_profile/UserProfileEdit')
            },
            {
                name: 'CrowdCompany',
                path: 'company',
                alias: ['/company', '/crowd/company', 'company'],
                component: () => import('@/views/loyalty/components/user_profile/UserProfileCompanyList'),
                props: route => ({ query: route.query.customerName })
            },
            {
                name: 'CrowdPlace',
                path: 'place',
                component: () => import('@/views/loyalty/components/user_profile/UserProfilePlaceList'),
            },
            {
                name: 'CrowdPlaceView',
                path: 'place/view',
                component: () => import('@/views/loyalty/components/user_profile/UserProfilePlaceView'),
            },
            {
                name: 'CrowdTransaction',
                path: 'transaction',
                component: () => import('@/views/loyalty/components/user_profile/UserProfileTransactionList')
            },
            {
                name: 'CrowdAccount',
                path: 'account',
                component: () => import('@/views/loyalty/components/user_profile/UserProfileAccountList')
            }
        ]
    },
]
